import React from 'react'
import './note.css'

const Note = (props) => {
    return(
        <div className='admin-note' style={props.note.important ? {border: '2px solid red'} : {border: 'none'}}>
            <img className='admin-note-admin-image' src={`./${props.note.author.toLowerCase().replace(/\s/g, '')}.jpg`}/>
            <div className='admin-note__name'>{props.note.author.split(' ')[0]}</div>
            <div className='admin-note__icon-wrapper'>
                {props.userData.Name === props.note.author && <img className='admin-note__edit-btn' src='./edit.svg' onClick={() => props.setEditNote(props.note)} />}
                {props.note.connections.length > 0 && <img className='admin-note__link-svg' src='./link.svg' />}
            </div>
            <div className='admin-note__date'>{new Date(props.note.date).getMonth() + 1}/{new Date(props.note.date).getDate()}/{new Date(props.note.date).getFullYear()}</div>
            <div className='admin-note__details'>{props.note.details}</div>
        </div>
    )
}
export default Note